module.exports = __webpack_public_path__ + "static/media/close-btn.214c28af.svg";